<div class="heading">
    <p *ngIf="is_active">Inactivate Category</p>
    <p *ngIf="!is_active">Activate Category</p>
</div>
<div class="cat-instruction">
    <p class="mb-32" *ngIf="is_active">Are you sure you want to deactivate the "{{categoryTitle}}" category? Once deactivated, the prompts mapped under "{{categoryTitle}}" and its subcategories will no longer be accessible to end users.</p>
    <p *ngIf="!is_active">Select Activate to activate "{{categoryTitle}}" category</p>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12" (click)="cancelInactivateCategory()"></app-button>
    <app-button *ngIf="is_active" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Inactivate'" class="w-50" (click)="inactivateCategory()"></app-button>
    <app-button *ngIf="!is_active" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Activate'" class="w-50" (click)="inactivateCategory()"></app-button>
</div>